<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >

    <div class="d-sm-flex align-items-center">
        <button
           @click="openCreateModal"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
        >
          Nouvelle demande
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
     
      <div class="d-sm-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search "
          v-model="searchTerm"
          @change="filter()"
              @input="handleInput"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field === 'type'">
            <div
              v-if="props.row.type == 'SIMPLE_PARCEL'"
              class="badge text-bg-warning fs-13 me-5 mt-10"
            >
              Colis Simple
            </div>
            <div
              v-if="props.row.type == 'SIMPLE_STOCK'"
              class="badge text-bg-info fs-13 me-5 mt-10"
            >
              Colis de stock
            </div>
          </span>

          <span v-else-if="props.column.field === 'statut'">
            <div
              :class="`fs-13 me-5 mt-10 badge text-bg-${resolveUStatus(0)}`"
              class="text-capitalize"
            >
              {{ props.row.statut }}
            </div>
          </span>
          

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>

    <!-- Modal for Nouvelle Demande using Bootstrap classes -->
    <div
      class="modal fade"
      id="modal-ville"
      tabindex="-1"
      aria-labelledby="modalVilleLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="submitRequest">
            <div class="modal-header">
              <h5 class="modal-title" id="modalVilleLabel">Nouvelle Demande</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="type_request" class="form-label">Type de ramassage *</label>
                <select
                  id="type_request"
                  class="form-select"
                  v-model="type_request"
                  required
                >
                  <option value="" disabled>Choisir le type</option>
                  <option value="SIMPLE_PARCEL">Ramassage Colis</option>
                  <option value="SIMPLE_STOCK">Ramassage Stock</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="phone" class="form-label">Téléphone *</label>
                <input
                  type="text"
                  id="phone"
                  class="form-control"
                  v-model="phone"
                  placeholder="Téléphone*"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="city" class="form-label">Ville de reception *</label>
                <v-select
                  class="custom-select-height"
                  v-model="city"
                  label="name"
                  :options="citiesList"
                  required
                />

              </div>
              <div class="mb-3">
                <label for="adresse" class="form-label">Adresse</label>
                <textarea
                  id="adresse"
                  class="form-control"
                  rows="2"
                  v-model="adresse"
                  placeholder="Adresse*"
                ></textarea>
              </div>
              <div class="mb-3">
                <label for="remarque" class="form-label">Remarque</label>
                <textarea
                  id="remarque"
                  class="form-control"
                  rows="2"
                  v-model="remarque"
                  placeholder="Remarque*"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-success">
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {  onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Modal } from "bootstrap";
export default {
  name: "PickupRequests",
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      {
          label: "Type",
          field: "type",
        },
        {
          label: "Remarques",
          field: "note",
        },
        {
          label: "Téléphone",
          field: "phone",
        },
        {
          label: "Ville",
          field: "city",
        },
        {
          label: "Adresse",
          field: "address",
        },
        {
          label: "Date d'ajout",
          field: "created_at",
        },
        {
          label: "Etat",
          field: "statut",
        },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
     searchCity: "",
        searchStatut: "",
        searchType: "",
        searchSDate: "",
        searchEDate: "",
        searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const citiesList = ref([]);
    const type_request = ref("");
    const phone = ref("");
    const adresse = ref("");
    const remarque = ref("");
    const city =  ref<any>({});
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const type_filter = ref("");
    const date_filter = ref(null);

    // const TypeList = [
    //     { name: "Ramassage Colis", value: "SIMPLE_PARCEL" },
    //     { name: "Ramassage Stock", value: "SIMPLE_STOCK" },
    // ];

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/client/list_request_pickup`, {
          params: {
            searchTerm: users.searchTerm,
            searchCity: users.searchCity,
            searchStatut: users.searchStatut,
            searchType: users.searchType,
            searchSDate: users.searchSDate,
            searchEDate: users.searchEDate,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
      try {
        const res = await api.get("/api/auth/client/citiesList");
        citiesList.value = res.data;
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }


    function resolveUStatus(status) {
      if (status === 0) return "primary";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "danger";
    }


    // Filter function to update search parameters and fetch data
    function filter() {
      users.searchCity = city_filter.value.id;
      users.searchStatut = status_filter.value;
      users.searchType = type_filter.value;
      users.searchSDate =
      date_filter.value && date_filter.value.start
        ? convert(date_filter.value.start)
        : "";
      users.searchEDate =
      date_filter.value && date_filter.value.end
        ? convert(date_filter.value.end)
        : "";
      users.current_page = 1;
      fetchData();
    }

    // Remove all filters and reset search parameters
    function Removefilter() {
      users.searchType = "";
      users.searchCity = "";
      users.searchStatut = "";
      users.searchSDate = "";
      users.searchEDate = "";
      status_filter.value = "";
      type_filter.value = "";
      city_filter.value = { id: "", name: "" };
      date_filter.value = null;
      fetchData();
    }


    function convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    // Debounced input handler for search
    const debounceTimer = ref<number | null>(null);
    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);

      debounceTimer.value = setTimeout(() => {
      users.searchTerm = searchTerm.value;
      fetchData();
      }, 500); // Adjust the delay (in milliseconds) as needed
    }

    // Add searchTerm ref for v-model
    const searchTerm = ref("");

    async function submitRequest() {
      if (!type_request.value || !phone.value || !city.value.id) {
        showToast("Veuillez remplir tous les champs obligatoires.", "error");
        return;
      }

      try {
        let data = new FormData();
        data.append("type_request", type_request.value);
        data.append("phone", phone.value);
        data.append("adresse", adresse.value);
        data.append("remarque", remarque.value);
        data.append("city_id", city.value.id);

        const res = await api.post("/api/auth/client/add_request_pickup",data);
        if (res.data.message == "success"){
          showToast("Demande de ramassage créée avec succès.", "success");

          // Reset form fields
          type_request.value = "";
          phone.value = "";
          adresse.value = "";
          remarque.value = "";
          city.value = {};

          // Close modal

          const modalEl = document.getElementById("modal-ville");
            const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
            modal.hide();


          // Refresh data
          fetchData();  
        }else{
          showToast("Une erreur s'est produite lors de la création de la demande.", "error");
        }
        
      } catch (error) {
        console.error(error);
        showToast("Une erreur s'est produite lors de la création de la demande.", "error");
      }
    }


     function openCreateModal() {

      const modalEl = document.getElementById("modal-ville");
      const modal = new Modal(modalEl);
      modal.show();
    }


    return {
      auth,
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      resolveUStatus,
      citiesList,
      type_request,
      phone,
      adresse,
      remarque,
      city,
      city_filter,
      status_filter,
      type_filter,
      date_filter,
      // TypeList,
      searchTerm,
      filter,
      Removefilter,
      handleInput,
      submitRequest,
      openCreateModal

    };
  },
};
</script>